import styled from 'styled-components'

export const WishlistCTAContainer = styled.button<{
  layout: 'tile' | 'tile-inverted' | 'button' | 'absolute-button'
  $isFilled?: boolean
  $isLoading?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;

  ${({ layout }) =>
    layout === 'tile' &&
    `
        position: absolute; 
        top: 0; 
        right: 0; 
        border: none;
        width: 4.8rem;
        height: 4.8rem;
    `}

  ${({ layout }) =>
    layout === 'tile-inverted' &&
    `
      position: absolute;
      top: 0; 
      right: 0;
      border: none;
      width: 4.45rem;
      height: 4.45rem;
    `}

  ${({ layout, theme }) =>
    layout === 'button' &&
    `
    border: 1px solid ${theme.colors.secondary};
    height: 4.45rem;
      width: 4.45rem;
    `}

  ${({ layout, theme }) =>
    layout === 'absolute-button' &&
    `
      position: absolute;
      top: 0; 
      right: 0;
      border: 1px solid ${theme.colors.secondary};
      height: 4.45rem;
      width: 4.45rem;
    `}


  svg {
    width: 1.1rem;
    height: 1.8rem;

    path {
      ${({ layout, theme }) =>
        `stroke: ${layout === 'tile' ? 'white' : theme.colors.text.primary};`}
      ${({ $isFilled, $isLoading, layout, theme }) =>
        ($isFilled || $isLoading) &&
        `
        fill: ${layout === 'tile' ? 'white' : theme.colors.text.primary};
      `}
    }
  }

  ${({ $isLoading, layout, theme }) =>
    $isLoading &&
    `
    svg {
      animation: spin 1s linear infinite;
      fill: ${layout === 'tile' ? 'white' : theme.colors.text.primary};
    }
  `}

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
